<template>
  <div class="index-container">
    <el-card class="cardDiv">
      <div slot="header">
        <span>服务通知</span>
      </div>
      <!-- <el-table :show-header="false" :data="noticeList" style="border: 1px solid #ebeef5;" v-if="noticeList.length>0">
              <el-table-column prop="desc">
                  <template slot-scope="scope">
                      <span v-if="scope.row.link" class="uline red"><a :href="scope.row.url" target="_blank">{{scope.row.desc}}</a></span>
                      <span v-else class="uline" @click="openDialog(scope.row)">{{scope.row.desc}}</span>
                  </template>
              </el-table-column>
              <el-table-column prop="fCreateTime" width="160">
              </el-table-column>
          </el-table> -->
      <ul>
        <li class="serveNotice" v-if="hasActivity">
          <span @click="signDialogVisible = true" class="uline red"><span>【{{activityInfo.name}}】</span>银行活动巨额优惠补贴来袭</span>
          <el-button type="text" class="checkBtn" @click="signDialogVisible = true">查看</el-button>
        </li>
        <li v-for="(item,key) in noticeList" :key="key" class="serveNotice" v-show="[1, 3].includes(roleId) || item.linkType !== 2">
          <span v-if="item.linkType === 2" @click="pageJump(item.url)" class="uline" :class="{'red': item.isImportant}"><span>{{ item.title }}</span>{{ item.desc }}</span>
          <span v-else-if="item.linkType === 1"><a :href="item.url" target="_blank" :class="{'red': item.isImportant}"><span>{{ item.title }}</span>{{ item.desc }}</a></span>
          <span v-else @click="openDialog(item)" class="uline" :class="{'red': item.isImportant}"><span>{{ item.title }}</span>{{ item.desc }}</span>
          <el-button type="text" class="checkBtn" v-if="item.linkType === 2" @click="pageJump(item.url)">查看</el-button>
          <el-button type="text" class="checkBtn" v-else-if="item.linkType === 1"><a :href="item.url" target="_blank">查看</a></el-button>
          <el-button type="text" class="checkBtn" v-else @click="openDialog(item)">查看</el-button>
        </li>
      </ul>
    </el-card>
    <not-read-notice></not-read-notice>
    <div class="index-text">欢迎使用乐刷代理商系统</div>
    <!-- <div class="index-text">name:{{name}}</div> -->
    <!-- <div class="index-text">role:<span v-for='role in roles' :key='role'>{{role}}</span></div> -->
    <!--      <login-notice :visible.sync="showNotice"></login-notice>-->
    <el-dialog :visible="showDialog" title="服务通知" :width="width" @close="showDialog = false">
      <img :src="showImg" alt="" style="width: 100%"/>
    </el-dialog>
    <el-dialog
      title="活动报名"
      v-if="signDialogVisible"
      :visible.sync="signDialogVisible"
      width="440px"
      @close="getList"
      :close-on-click-modal="false">
      <iframe :src="h5Link" frameborder="0" style="height: 750px;width: 400px;"></iframe>
      <div style="text-align: right;margin-top: 20px">
        <el-button @click="signDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import qs from 'qs'
// import loginNotice from '@/components/LoginNotice/loginNotice';
import NotReadNotice from './components/notReadNotice-back'
import { getH5Domain } from '@/utils/domain'
import { logout } from '@/api/user'
import { activityNotify } from '@/api/home'
export default {
  name: 'Index',
  components: {
    NotReadNotice
  },
  computed: {
    h5Link () {
      return `${getH5Domain()}union-receipt-h5/#/activity-sign?merchantId=${this.$store.getters.userId}&activityId=${this.activityInfo.code}`
    }
  },
  data () {
    return {
      // linkType 0: 不跳转 1： 第三方新页面跳转 2： 本地跳转
      noticeList: [
        {
          title: '【乐刷公告】',
          desc: '关于降低小微企业和个体工商户收单服务费的通知',
          image: require('../../../static/images/merchantRate.png'),
          isImportant: false,
          linkType: 0,
          width: 1000
        },
        {
          title: '【乐刷公告】',
          desc: '关于冒充“乐刷”实施诈骗行为的声明',
          image: require('../../../static/images/declaration.png'),
          isImportant: false,
          linkType: 0
        },
        {
          title: '【乐刷公告】',
          desc: '关于6个{yeahka}相关旧域名停用的通知',
          image: require('../../../static/images/declaration-domain.png'),
          isImportant: true,
          linkType: 0
        },
        {
          title: '【乐刷公告】',
          desc: '即日起乐刷开放新疆区域的商户进件，请知悉！',
          isImportant: false,
          linkType: 2,
          url: '/Merchant/MerchantManage/AddMerchant' //  本地跳转，跳转至代理商页面
        }
      ],
      showDialog: false,
      showImg: '',
      roleId: '',
      hasActivity: false,
      activityInfo: {},
      signDialogVisible: false,
      width: '800px'
    }
  },
  methods: {
    getLoginInfo () {
      var userName = this.$store.getters.userName
      var userId = this.$store.getters.userId
      this.roleId = this.$store.getters.roleId
      if (userName === '' || userId === undefined || userName === null) {
        var that = this
        logout({}).then(data => {
          that.$router.push('/login')
        })
      }
      if (this.roleId === 1 || this.roleId === 3) {
        this.$jquery('.index-text').html('欢迎使用智掌柜代理商管理系统')
        this.$jquery('.scroll-title').html('智掌柜代理商管理系统<br>代理商系统')
      } else {
        this.$jquery('.index-text').html('欢迎使用乐刷商户系统')
        this.$jquery('.scroll-title').html('智掌柜代理商管理系统<br>商户系统')
        this.$jquery('.menu-wrapper .el-submenu a:last-child').show()
      }
      this.$store.state.app.visitedViews.splice(0, this.$store.state.app.visitedViews.length)
    },
    openDialog (row) {
      this.showImg = row.image
      this.showDialog = true
      this.width = row.width ? `${row.width}px` : '800px'
    },
    // 跳转至本地页面
    pageJump (url) {
      this.$router.push(url)
    },
    getActivity () {
      activityNotify().then(res => {
        if (res.data) {
          this.hasActivity = true
          this.activityInfo = res.data
        }
      })
    }
  },
  mounted () {
    console.log(process.env)
    this.getLoginInfo()
    this.getActivity()
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.index {
  &-container {
    margin: 10px 10px 20px 16px;
      .cardDiv{
          margin-bottom: 30px;
      }
  }
  &-text {
    color: #5f6783;
    font-size: 30px;
    line-height: 46px;
    text-align: center;
    margin-top: 5vh;
  }
}
.red {
  color:red;
}
.uline {
  // text-decoration: underline;
  cursor: pointer
}
.serveNotice {
  height:50px;
  width:1000px;
  position: relative;
  background:rgba(246,249,255,1);
  border:1px solid rgba(231,239,255,1);
  border-radius:2px;
  margin-bottom:14px;
  line-height:50px;
    .circle {
      display:inline-block;
      width:6px;
      height:6px;
      background:rgba(64,158,255,1);
      border-radius:50%;
      margin-left:15px;
      position:relative;
      top:-3px
    }
    .checkBtn {
      position: absolute;
      right:108px;
      top:3px;
    }
}

</style>
